import { render } from "./UpdateElement.vue?vue&type=template&id=b7ffff48&scoped=true"
import script from "./UpdateElement.vue?vue&type=script&lang=js"
export * from "./UpdateElement.vue?vue&type=script&lang=js"

import "./UpdateElement.vue?vue&type=style&index=0&id=b7ffff48&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7ffff48"]])

export default __exports__